var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('button',{staticClass:"w3-button w3-text-theme",attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('toggleOn')}}},[_c('i',{staticClass:"far fa-times-circle"}),_vm._v("  Remove")])])}
var staticRenderFns = []

export { render, staticRenderFns }